import React, { useState } from "react";
import "./style.scss";

const steps = [
    "Finding Session",
    "Connecting with Cinema",
    "Checking Available Seats",
    "Redeeming Vouchers",
    "Completing Transaction",
    "Booking Succeeded",
    "Sending your tickets shortly"
];

const stepDescriptions = {
    "Finding Session": "The AI assistant is currently locating a suitable session for your booking.",
    "Connecting with Cinema": "Logging into the cinema system...",
    "Checking Available Seats": "Fetching seat map from cinema...",
    "Redeeming Vouchers": "Applying your vouchers...",
    "Completing Transaction": "Entering your payment details...",
    "Booking Succeeded": "Cinema has confirmed your booking.",
    "Sending your tickets shortly": "Generating and sending tickets now..."
};

const SuccessWithCinema = () => {
    const [activeStep, setActiveStep] = useState(0);

    return (
        <div className="booking-progress">
            <ul className="booking-progress__steps">
                {steps.map((label, index) => (
                    <li
                        role="button"
                        key={label}
                        className={`booking-progress__step ${index === activeStep ? "active" : ""}`}
                        onClick={() => setActiveStep(index)}
                    >
                        <div className="booking-progress__circle">{index + 1}</div>
                        <div className="booking-progress__label">{label}</div>
                    </li>
                ))}
            </ul>

            <div className="booking-progress__status">
                <div className="booking-progress__title">{steps[activeStep]}</div>
                <div className="booking-progress__text">{stepDescriptions[steps[activeStep]]}</div>
            </div>
        </div>
    );
};

export default SuccessWithCinema;
